<template>
  <div class="content">
    <VerbalIdentityIntroSecition/>
    <OurVerbalIdentityIntroSection/>        
    
  </div>
</template>

<script lang="ts">
import VerbalIdentityIntroSecition from '@/components/VerbalIdentityPage/sections/verbal-identity/VerbalIdentityIntroSecition.vue'
import OurVerbalIdentityIntroSection from '@/components/VerbalIdentityPage/sections/verbal-identity/OurVerbalIdentityIntroSection.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    VerbalIdentityIntroSecition,
    OurVerbalIdentityIntroSection   
    
  }
})
export default class VerbalIdentityView extends Vue {}
</script>

<style lang="scss"></style>
